module.exports = __webpack_public_path__ + "media/images/index-sticky-feature-bg-416db6d161bd62bc3ea84e626e490dd4.svg";